import script from "./saleProfitReportYearly.vue?vue&type=script&setup=true&lang=js"
export * from "./saleProfitReportYearly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__